import React from "react";
import { Popover, Stack, Text } from "@bookingcom/bui-react";
export const FlightCardBadgePopoverWrapper = ({ hover, children }) => {
    if (!hover)
        return React.createElement(React.Fragment, null, children);
    return (React.createElement(Popover, { triggerType: "hover", position: "bottom" },
        React.createElement(Popover.Trigger, null, (attributes) => React.createElement("span", { ...attributes }, children)),
        React.createElement(Popover.Content, null,
            React.createElement(Stack, { direction: "column", gap: 1 },
                React.createElement(Text, { variant: "strong_1" }, hover.title),
                React.createElement(Text, { variant: "body_1" }, hover.text)))));
};
